module.exports = __webpack_public_path__ + "img/finished-project-participant-disqualification.c00f090b.png";